import { API_BASE } from '../config/api';

const withAuth = (token) => ({
  'Content-Type': 'application/json',
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

const parse = async (response, fallback) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || fallback);
  return data;
};

export const trackProfileVisit = async (userId, token) =>
  parse(
    await fetch(`${API_BASE}/api/profiles/${userId}/visit`, { method: 'POST', headers: withAuth(token) }),
    'Failed to track visit.'
  );

export const fetchMyVisitSummary = async (token) =>
  parse(await fetch(`${API_BASE}/api/profiles/me/visits-summary`, { headers: withAuth(token) }), 'Failed to load visit summary.');

export const followUser = async (userId, token) =>
  parse(await fetch(`${API_BASE}/api/follow/${userId}`, { method: 'POST', headers: withAuth(token) }), 'Failed to follow user.');

export const unfollowUser = async (userId, token) =>
  parse(await fetch(`${API_BASE}/api/follow/${userId}`, { method: 'DELETE', headers: withAuth(token) }), 'Failed to unfollow user.');

export const fetchFollowStatus = async (userId, token) =>
  parse(await fetch(`${API_BASE}/api/follow/${userId}/status`, { headers: withAuth(token) }), 'Failed to load follow status.');

export const fetchFollowCounts = async (userId) =>
  parse(await fetch(`${API_BASE}/api/users/${userId}/follow-counts`), 'Failed to load follow counts.');

export const fetchFollowers = async (userId, page = 1, limit = 10) =>
  parse(await fetch(`${API_BASE}/api/users/${userId}/followers?page=${page}&limit=${limit}`), 'Failed to load followers.');

export const fetchFollowing = async (userId, page = 1, limit = 10) =>
  parse(await fetch(`${API_BASE}/api/users/${userId}/following?page=${page}&limit=${limit}`), 'Failed to load following.');

export const upsertPlayerRating = async (playerUserId, payload, token) =>
  parse(
    await fetch(`${API_BASE}/api/ratings/players/${playerUserId}`, {
      method: 'POST',
      headers: withAuth(token),
      body: JSON.stringify(payload),
    }),
    'Failed to submit player rating.'
  );

export const fetchPlayerRatingSummary = async (playerUserId, token) =>
  parse(await fetch(`${API_BASE}/api/ratings/players/${playerUserId}/summary`, { headers: withAuth(token) }), 'Failed to load player rating summary.');

export const upsertCaptainRating = async (captainUserId, payload, token) =>
  parse(
    await fetch(`${API_BASE}/api/ratings/captains/${captainUserId}`, {
      method: 'POST',
      headers: withAuth(token),
      body: JSON.stringify(payload),
    }),
    'Failed to submit captain rating.'
  );

export const fetchCaptainRatingSummary = async (captainUserId, token) =>
  parse(await fetch(`${API_BASE}/api/ratings/captains/${captainUserId}/summary`, { headers: withAuth(token) }), 'Failed to load captain rating summary.');
